import { useState, useRef, useEffect } from "react";
import normatecaStore from "../../../stores/normatecaStore";
import ScreenResize from '../ScreenResize/ScreenResize';
import {Accordion, AccordionBody, AccordionHeader, AccordionItem} from "react-headless-accordion";

export default function Ordena(param){
     // store - zuntand
     const { setOrdenar,tipoOrdena,tipoOrdenaB,ordenamiento,opcMenu} =
     normatecaStore((state) =>( { 
       setOrdenar: state.setOrdenar,
       tipoOrdena:state.tipoOrdena,
       tipoOrdenaB:state.tipoOrdenaB,
       ordenamiento:state.ordenamiento,
       opcMenu: state.opcMenu,
   })); 
    const screen= ScreenResize();
    const ord = useRef(null);
    const [visMenu, setVisMenu]= useState(false);
    const changeOrdena=(indiceOrd)=>{
        setVisMenu(false);
        setOrdenar(indiceOrd,param.opc).catch(null);
    }
    const visualizaMenu=()=>{
        setVisMenu(!visMenu);
    }
    useEffect(() => {
        document.addEventListener("click", clickOutsideOrd, false);
        return () => {
        document.removeEventListener("click", clickOutsideOrd, false);
        };
    }, []);
    const clickOutsideOrd = event => {
        if (ord.current && !ord.current.contains(event.target)) {
            setVisMenu(false);
        }
    };
    return(
        <div className="display-flex divOrdenaPrin">
            <div className={opcMenu==="bus" || opcMenu==="busAva" || opcMenu==="busAvaOpc"? "":"width-62"}></div>
            <div className={opcMenu.includes("bus") && screen.width<768? "divOrdenaMovilBus":"divOrdena"}  ref={ord}>
                <Accordion className="divAcoordionOrdena">
                        <AccordionItem key={0} >
                            <AccordionHeader className="menuOrdena display-flex" onClick={visualizaMenu}>
                                <div id="ordena" className="width-95">{ordenamiento}</div> 
                                <div id="ordena2" className={visMenu? "inegi-nav-despa alignSelf-center color-blue padleft-05": "inegi-nav-desp alignSelf-center color-blue padleft-05"}></div>
                            </AccordionHeader>
                            <AccordionBody className={visMenu? 'display-initial' : 'display-none'}>
                                <div id="div1" className="accordion-body divOpcOdena" key={"div1"} >
                                    <AccordionItem key={"aci"}>
                                        {param.opc==="m"?
                                            tipoOrdena.map((or,index) => {
                                                return (
                                                    <div id={"orTO" + index.toString()} key={"orTO" + index.toString()} className="accordion-body divOpcOrdenaItem"  onClick={()=>changeOrdena(index)}>
                                                        {or}
                                                    </div>
                                                );
                                            })
                                        :
                                            tipoOrdenaB.map((or,index) => {
                                                return (
                                                    <div id={"orTOB" + index.toString()} key={"orTOB" + index.toString()} className="accordion-body divOpcOrdenaItem"  onClick={()=>changeOrdena(index)}>
                                                        {or}
                                                    </div>
                                                );
                                            })
                                        }
                                </AccordionItem>
                                </div>
                            </AccordionBody>
                        </AccordionItem>
                        </Accordion>
            </div>
         </div>
    )
}